import { render, staticRenderFns } from "./RowDestroy.vue?vue&type=template&id=22205598&"
import script from "./RowDestroy.vue?vue&type=script&lang=js&"
export * from "./RowDestroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports